/* Progressive enhancement only. Native contact form and accordions work without JS. */
(() => {
  if (window.TotokaCustomerCareS26) return;
  const instances = new Map();
  const normalise = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  function mount(root) {
    if (instances.has(root)) return;
    const abort = new AbortController();
    const signal = abort.signal;
    const tools = root.querySelector('[data-care-tools]');
    const search = root.querySelector('[data-care-search]');
    const buttons = [...root.querySelectorAll('[data-care-filter]')];
    const items = [...root.querySelectorAll('[data-care-question]')];
    const empty = root.querySelector('[data-care-empty]');
    const count = root.querySelector('[data-care-count]');
    let group = 'all';
    const records = items.map(element => ({element, text:normalise(element.textContent)}));
    function filter() {
      const query = normalise(search?.value);
      let visible = 0;
      for (const {element, text} of records) {
        const match = (group === 'all' || element.dataset.group === group) && (!query || text.includes(query));
        element.hidden = !match;
        if (match) visible++;
      }
      for (const button of buttons) button.setAttribute('aria-pressed', String(button.dataset.careFilter === group));
      if (empty) empty.hidden = visible !== 0;
      if (count) count.textContent = `${count.dataset.prefix} ${visible}`;
    }
    if (tools && search) {
      tools.hidden = false;
      for (const button of buttons) {
        const key = button.dataset.careFilter;
        button.hidden = key !== 'all' && !items.some(item => item.dataset.group === key);
      }
      search.addEventListener('input', filter, {signal});
      tools.addEventListener('click', event => {
        const button = event.target.closest('[data-care-filter]');
        if (!button || !tools.contains(button)) return;
        group = button.dataset.careFilter;
        filter();
      }, {signal});
      filter();
    }
    root.addEventListener('shopify:block:select', event => {
      group = 'all';
      if (search) search.value = '';
      filter();
      const item = event.target.closest('[data-care-question]');
      if (item && root.contains(item)) item.open = true;
    }, {signal});
    const result = root.querySelector('[data-care-form-result]');
    if (result && !window.Shopify?.designMode) result.focus();
    instances.set(root, () => {abort.abort(); if (tools) tools.hidden = true; for (const item of items) item.hidden = false;});
  }
  function scan(scope = document) {
    if (scope.matches?.('[data-totoka-care]')) mount(scope);
    scope.querySelectorAll('[data-totoka-care]').forEach(mount);
  }
  function unload(scope) {
    for (const [root, destroy] of instances) if (root === scope || scope.contains(root)) {destroy(); instances.delete(root);}
  }
  window.TotokaCustomerCareS26 = {scan};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), {once:true});
  else scan();
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => unload(event.target));
})();
